import { useContext, useCallback } from 'react';
import { Transforms } from 'slate';
import { v4 as uuidv4 } from 'uuid';
import ClientContext from '../contexts/ClientContext';
import { IMAGE_TYPE, AUDIO_TYPE } from '../constants/mediaTypes';
import useAuthenticatedRestCall from './useAuthenticatedRestCall';

const mediaPathNames = new Map([[IMAGE_TYPE, "course-images"], [AUDIO_TYPE, "course-audio"]])

export const useUploadCourseContentMedia = (editor, selection, nodeProps,) => {
  const { clientInfo } = useContext(ClientContext);
  const makeAuthenticatedRequest = useAuthenticatedRestCall();

  return useCallback(
    (event) => {
      event.preventDefault();
      const id = uuidv4();

      const files = event.target.files;
      if (files.length === 0) {
        return;
      }
      const file = files[0];
      const tempFile = URL.createObjectURL(file);
      const formData = new FormData();
      const date = Date.now();
      const uniqueFileName = `${date}-${id}-${file.name}`;
      formData.append('upload', file, uniqueFileName);

      Transforms.insertNodes(
        editor,
        [
          {
            id,
            src: tempFile,
            isUploading: true,
            children: [{ text: '' }],
            ...nodeProps
          },
        ],
        { at: selection, select: true }
      );

      return makeAuthenticatedRequest(
        `${process.env.REACT_APP_IMAGE_SERVICE_URL}/clients/${clientInfo.clientId}/${mediaPathNames.get(nodeProps.type)}`,
        true,
        {
          data: formData,
          method: 'POST',
        },
        { 'Content-Type': 'multipart/form-data' }
      )
        .then((response) => {
          const { location } = response.data;

          Transforms.setNodes(
            editor,
            { isUploading: false, src: location },
            { match: (n) => n.id === id, at: [] }
          );

          if (nodeProps.type === IMAGE_TYPE) {
            Transforms.insertNodes(
              editor,
              [
                {
                  type: 'paragraph',
                  children: [{ text: '' }],
                },
              ],
              { at: selection, select: true }
            );
          }
        })
        .catch((error) => {
          // Fire another Transform.setNodes to set an upload failed state on the image
          console.log(error);
        });
    },
    [editor, selection, clientInfo.clientId, makeAuthenticatedRequest, nodeProps]
  );
};
